import BackrsLogoSmallFilled from '@backrs_ui/common-ui/src/assets/images/backrs-logo-filled.svg';
import { AppIcon, AppIcons } from '@backrs_ui/common-ui/src/designSystem/icons/AppIcon';

import { Box, SxProps, Theme, Typography } from '@mui/material';

type BadgeIconMode =
  | { mode: 'appIcon'; icon: AppIcons }
  | { mode: 'avatar'; avatarUrl: string }
  | { mode: 'backrsLogo' };

export type NuggetBadgeProps = Readonly<{
  label: string;
  iconConfig: BadgeIconMode;
}>;

export const NuggetBadge = ({ label, iconConfig }: NuggetBadgeProps) => {
  return (
    <Box sx={badgeContainerSx}>
      {iconConfig.mode === 'appIcon' && (
        <AppIcon iconName={iconConfig.icon} diameter="12px" color="Brand/500" />
      )}
      {iconConfig.mode === 'avatar' && (
        <Box
          component="img"
          src={iconConfig.avatarUrl}
          alt=""
          sx={circularImageSx}
          onError={(e: React.SyntheticEvent<HTMLImageElement>) => {
            e.currentTarget.style.display = 'none';
          }}
        />
      )}
      {iconConfig.mode === 'backrsLogo' && (
        <Box component="img" src={BackrsLogoSmallFilled} alt="" sx={circularImageSx} />
      )}
      <Typography variant="text-sm-medium" sx={labelSx}>
        {label}
      </Typography>
    </Box>
  );
};

const badgeContainerSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: backrs.spacing['spacing-xs'],
  backgroundColor: backrs.colors['Colors/Background/bg-primary'],
  border: `1px solid ${backrs.colors['Colors/Foreground/fg-secondary']}`,
  borderRadius: backrs.radius['radius-md'],
  paddingLeft: backrs.spacing['spacing-md'],
  paddingRight: '10px',
  paddingTop: backrs.spacing['spacing-xs'],
  paddingBottom: backrs.spacing['spacing-xs'],
});

const circularImageSx: SxProps<Theme> = {
  width: 16,
  height: 16,
  borderRadius: '50%',
  objectFit: 'cover',
  flexShrink: 0,
};

const labelSx: SxProps<Theme> = ({ backrs }) => ({
  color: backrs.colors['Colors/Text/text-secondary'],
  whiteSpace: 'nowrap',
});
